import React from 'react'

function Privacy() {
    return (
        <div className="container py-5">
            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4 p-md-5">

                    <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
                        Privacy Policy
                    </h5>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        Thanks for visiting website of Tamil Nadu Warehousing Corporation, and reviewing our privacy policy. We collect no personal information,
                        like names or addresses, when you visit our website. If you choose to provide that information to us, it is only used to fulfil your request for
                        information. We do collect some technical information when you visit to make your visit seamless. The section below explains how we handle
                        and collect technical information when you visit our website. Information collected and stored automatically:
                    </p>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        When you browse, read pages, or download information on this website, we automatically gather and store certain technical information
                        about your visit. This information never identifies who you are. The information we collect and store about your visit is listed below:
                    </p>

                    <ul className="text-secondary lh-lg mb-4">
                        <li>
                            The Internet domain of your service provider (e.g. mtnl.net.in) and IP address (an IP address is a number that is automatically assigned
                            to your computer whenever you are surfing the web) from which you access our website.
                        </li>
                        <li>
                            The type of browser (such as Firefox, Netscape, or Internet Explorer) and operating system (Windows, Linux) used to access our site.
                        </li>
                        <li>
                            The date and time you access/accessed our site.
                        </li>
                        <li>
                            The pages/URLs you have visited, and
                        </li>
                        <li>

                            If you reached this website from another website, the address of that referring website.This information is only used to help us make
                            the site more useful for you. With this data, we learn about the number of visitors to our site and the types of technology our visitors
                            use. We never track or record information about individuals and their visits. Cookies: When you visit some websites, they may
                            download small pieces of software on your computer/browsing device known as cookies. Some cookies collect personal information
                            to recognise your computer in the future. We only use non-persistent cookies or “per-session cookies”
                        </li>
                    </ul>


                    <p
                        className="text-secondary lh-lg mb-0"
                        style={{ textIndent: "2.5rem" }}
                    >
                        Per-session cookies serve technical purposes, like providing seamless navigation through this website. These cookies do not collect
                        personal information on users and they are deleted as soon as you leave our website. The cookies do not permanently record data and they are
                        not stored on your computer’s hard drive. The cookies are stored in memory and are only available during an active browser session. Again,
                        once you close your browser, the cookie disappears. If you send us personal information:
                    </p>

                    <p
                        className="text-secondary lh-lg mb-0"
                        style={{ textIndent: "2.5rem" }}
                    >
                        We do not collect personal information for any purpose other than to respond to you (for example, to respond to your questions or provide
                        subscriptions you have chosen). If you choose to provide us with personal information-like filling out a Contact Us form, with an e-mail address
                        or postal address, and submitting it to us to obtain various services through the website-we use that information to respond to your message,
                        and to help you get the information you have requested. We only share the information you give us with another Government agency if your
                        question relates to that agency, or as otherwise required by law.
                    </p>
                    <p
                        className="text-secondary lh-lg mb-0"
                        style={{ textIndent: "2.5rem" }}
                    >
                        Our website never collects information or creates individual profiles for commercial marketing. While you must provide an email address
                        for a localised response to any incoming questions or comments to us, we recommend that you do NOT include any other personal information.
                    </p>

                    <h5 className="fw-bold text-success border-bottom pb-3 my-4">
                        Site Security
                    </h5>

                    <p className="text-secondary lh-lg mb-0">
                        <ul>
                            <li>
                                For site security purposes and to ensure that this service remains available to all users, this Government computer system employs
                                commercial software programs to monitor network traffic to identify unauthorised attempts to upload or change information, or
                                otherwise cause damage.
                            </li>

                            <li>
                                Except for authorised law enforcement investigations, no other attempts are made to identify individual users or their usage habits. Raw
                                data logs are used for no other purposes and are scheduled for regular deletion.
                            </li>

                            <li>
                                Unauthorised attempts to upload information or change information on this service are strictly prohibited and may be punishable under
                                the Indian IT Act b (2000).
                            </li>
                        </ul>
                    </p>

                </div>
            </div>
        </div>

    )
}

export default Privacy